import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../../UI/Button/Button';
import { RightArrowIcon } from '../../assets/icons';
import cardSrc from '../../assets/images/newsCard.png';
import { formatPublishDate } from '../../helpers/article';
import { useAppSelector } from '../../hooks/reduxHooks/useAppSelector';
import { PATH_DASHBOARD } from '../../routes/RouterConfig';
import { IArticleCard, Role } from '../../types/types';
import { DeleteModal } from '../DeleteModal/DeleteModal';
import { Tag } from '../Tag/Tag';
import styles from './ArticleCard.module.scss';

interface ArticleCardProps {
    article: IArticleCard;
}

export const ArticleCard = ({ article }: ArticleCardProps) => {
    const { role } = useAppSelector((state) => state.authReducer);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const navigate = useNavigate();

    const isStaff = role === Role.staff;
    const link = `/useful/${article.id}`;

    return (
        <div className={styles.card}>
            <Link to={link} className={styles.card__imagecontainer}>
                <img
                    className={styles.card__image}
                    src={article.image ?? cardSrc}
                    alt=""
                />
            </Link>
            <div className={styles.card__wrapper}>
                <div className={styles.card__tags}>
                    <Tag
                        type="rubric"
                        content={article.rubric.title}
                    />
                    {/* сотруднику видно, какой материал сейчас на главной */}
                    {isStaff && article.is_top ? (
                        <span className={styles.card__top}>На главной</span>
                    ) : null}
                </div>
                <Link to={link} className={styles.card__title}>
                    {article.title}
                </Link>
                <p className={styles.card__preview}>{article.preview}</p>
                <div className={styles.card__bottom}>
                    <Link to={link} className={styles.card__more}>
                        Подробнее
                        <span className={styles.card__more_icon}>
                            <RightArrowIcon />
                        </span>
                    </Link>
                    <span className={styles.card__date}>
                        {formatPublishDate(article.publish_date)}
                    </span>
                </div>
                {isStaff ? (
                    <div className={styles.buttons}>
                        <Button
                            onClick={() =>
                                navigate(`/staff/useful_edit/${article.id}`)
                            }
                        >
                            Редактировать
                        </Button>
                        <Button onClick={() => setShowDeleteModal(true)}>
                            Удалить
                        </Button>
                    </div>
                ) : null}
            </div>
            {showDeleteModal ? (
                <DeleteModal
                    backLink={PATH_DASHBOARD.staff.useful.root}
                    url={`/v1/article/${article.id}/`}
                    title="Вы действительно хотите удалить материал?"
                    successMessage="Материал удалён"
                    errorMessage="Материал не удалён"
                    onClose={() => setShowDeleteModal(false)}
                />
            ) : null}
        </div>
    );
};
